import { render, staticRenderFns } from "./DialogContentWhatsIncludedPersonalPossessions.vue?vue&type=template&id=69bc5b1c&scoped=true&"
import script from "./DialogContentWhatsIncludedPersonalPossessions.vue?vue&type=script&lang=js&"
export * from "./DialogContentWhatsIncludedPersonalPossessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc5b1c",
  null
  
)

export default component.exports